var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<mdc-select ng-model=\"$ctrl._model\" options=\"$ctrl.objs\" label=\"{{ ::$ctrl.label }}\" ng-change=\"$ctrl.onSelect()\" extra-classes=\"{{ ::$ctrl.extraClasses }}\" ng-if=\"$ctrl.loaded\" menu-id=\"{{ ::$ctrl.menuId }}\"></mdc-select>\n<div class=\"select-loading-indicator\" ng-if=\"$ctrl.loaded && $ctrl.loading\">\n<span ng-if=\"$ctrl.loadingText && $ctrl.loadingText.length > 0\">{{$ctrl.loadingText}}</span>\n<span class=\"select-spinner\" us-spinner=\"{\n      radius: 6,\n      lines: 8,\n      length: 0,\n      width: 5,\n      scale: 0.5,\n      corners: 1\n    }\"></span>\n</div>\n<span ng-if=\"!$ctrl.loaded\"></span>\n";
var id1="app/common/components/selector/selector.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/selector/selector.tpl.html
// module id = 482
// module chunks = 6